import { PlusIcon, XMarkIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react'
import { TextField }           from '../../'
import { Image }               from '../../Image'
import { SelectOption }        from '../../Select/Select'

export default function SettingsShopProductFormVariationsTableItem( props: any ): JSX.Element {
  const { appCdnUrl, images, handleVariantChange, variant, isColourVariation, isSizeVariation, shopVariantsVariations, shopVariants, tIndex } = props

  const [ imageId, setImageId ]                     = useState( variant?.image_id ?? '' )
  const [ selectedImageUrl, setSelectedImageUrl ]   = useState( '' )
  const [ colourVariationId, setColourVariationId ] = useState( '' )
  const [ sizeVariationId, setSizeVariationId ]     = useState( '' )
  const [ variantQuantity, setVariantQuantity ]     = useState( variant?.quantity ? `${ variant.quantity }` : '' )
  const [ variantPrice, setVariantPrice ]           = useState( variant?.price ? `${ variant.price }` : '' )
  const [ variantOrder, setVariantOrder ]           = useState( variant?.order ? `${ variant.order }` : '0' )

  const colourVariant: any    = shopVariants.find( ( v: any ): any => v.name === 'colour' )
  const sizeVariant: any      = shopVariants.find( ( v: any ): any => v.name === 'size' )
  const colourVariations: any = shopVariantsVariations.filter( ( v: any ): any => v.variant_id === colourVariant?.id )
  const sizeVariations: any   = shopVariantsVariations.filter( ( v: any ): any => v.variant_id === sizeVariant?.id )

  const resolveImageUrl: any = (): void => {
    const selectedImage: any = images.find( ( image: any ): any => image.id === imageId )

    setSelectedImageUrl( selectedImage ? selectedImage.url : '' )
  }

  const updateImage: any = ( image_id: any ): void => {
    if ( tIndex !== undefined && tIndex > -1 ) {
      handleVariantChange( 'update', { image_id }, tIndex )
    }

    setImageId( image_id )
  }

  const updateColour: any = ( colourId: any ): void => {
    if ( tIndex !== undefined && tIndex > -1 ) {
      handleVariantChange( 'updateConfig', { [ `${ colourVariant.id }` ]: colourId }, tIndex )
    }

    setColourVariationId( colourId )
  }

  const updateSize: any = ( sizeId: any ): void => {
    if ( tIndex !== undefined && tIndex > -1 ) {
      handleVariantChange( 'updateConfig', { [ `${ sizeVariant.id }` ]: sizeId }, tIndex )
    }

    setSizeVariationId( sizeId )
  }

  const updateQuantity: any = ( quantity: any ): void => {
    if ( tIndex !== undefined && tIndex > -1 ) {
      handleVariantChange( 'update', { quantity }, tIndex )
    }

    setVariantQuantity( `${ quantity }` )
  }

  const updateOrder: any = ( order: any ): void => {
    if ( tIndex !== undefined && tIndex > -1 ) {
      handleVariantChange( 'update', { order }, tIndex )
    }

    setVariantOrder( `${ order }` )
  }

  const updatePrice: any = ( price: any ): void => {
    if ( tIndex !== undefined && tIndex > -1 ) {
      handleVariantChange( 'update', { price }, tIndex )
    }

    setVariantPrice( `${ price }` )
  }

  const addVariant: any = (): any => {
    const data: any = {
      image_id: imageId,
      quantity: variantQuantity,
      order:    variantOrder,
      price:    variantPrice,
      config:   {}
    }

    if ( isColourVariation && colourVariant?.id ) {
      data.config[ `${ colourVariant.id }` ] = colourVariationId
    }

    if ( isSizeVariation && sizeVariant?.id ) {
      data.config[ `${ sizeVariant.id }` ] = sizeVariationId
    }

    handleVariantChange( 'add', data, tIndex )

    setImageId( '' )
    setSelectedImageUrl( '' )
    setColourVariationId( '' )
    setSizeVariationId( '' )
    setVariantQuantity( '' )
    setVariantPrice( '' )
  }

  useEffect( (): any => {
    if ( imageId ) {
      resolveImageUrl()
    } else {
      setSelectedImageUrl( '' )
    }
  }, [ imageId ] )

  useEffect( (): any => {
    let shouldFetch: boolean = true

    if ( shouldFetch && variant ) {
      if ( variant.config && Object.keys( variant.config ).length ) {
        Object.entries( variant.config ).forEach( ( c: any ): void => {
          const shopVariant: any = shopVariants.find( ( v: any ): any => v.id === c[ 0 ] )

          if ( shopVariant?.slug === 'size' ) {
            setSizeVariationId( `${ c[ 1 ] }` )
          }

          if ( shopVariant?.slug === 'colour' ) {
            setColourVariationId( `${ c[ 1 ] }` )
          }
        } )
      }

      setImageId( variant.image_id )
      setVariantQuantity( `${ variant.quantity }` )
      setVariantPrice( `${ variant.price }` )
    }

    return (): void => {
      shouldFetch = false
    }
  }, [ variant ] )

  return (
    <div className="flex overflow-hidden p-2 xl:p-4 shadow-soft rounded-2xl mt-3 2xl:mt-6 w-full space-x-4">
      <div className="flex justify-center flex-col w-full">
        { selectedImageUrl &&
          <div className="relative flex items-center justify-center w-full p-2 h-24 lg:h-36">
            <button
              className="absolute border-none right-2 top-2 w-6 h-6 rounded-full flex items-center justify-center text-white bg-red-500"
              onClick={ (): void => updateImage( '' ) }
            >
              <XMarkIcon />
            </button>

            <Image
              klass="max-h-full"
              src={ appCdnUrl + selectedImageUrl }
              alt={ imageId }
              defaultSrc={ '' }
            />
          </div>
        }

        <SelectOption
          setSelected={ ( id: any ): void => updateImage( id ) }
          selected={ imageId ?? '' }
          placeholder="Select image"
          fieldClasses="py-1 px-4 border rounded-2xl w-full text-blue-input placeholder-grey-input"
          options={ images.map( ( img: any, i: number ): any => {
            return { key: img.id, value: ( i + 1 ) }
          } ) }
        />
      </div>

      { isColourVariation &&
        <div className="flex justify-center flex-col w-full">
          <SelectOption
            setSelected={ ( colour: any ): void => updateColour( colour ) }
            selected={ colourVariationId ?? '' }
            placeholder="Select colour"
            fieldClasses="py-1 px-4 border rounded-2xl w-full text-blue-input placeholder-grey-input"
            options={ colourVariations.map( ( c: any ): any => {
              return { key: c.id, value: c.name }
            } ) }
          />
        </div>
      }

      { isSizeVariation &&
        <div className="flex justify-center flex-col w-full">
          <SelectOption
            setSelected={ ( size: any ): void => updateSize( size ) }
            selected={ sizeVariationId ?? '' }
            placeholder="Select size"
            fieldClasses="py-1 px-4 border rounded-2xl w-full text-blue-input placeholder-grey-input"
            options={ sizeVariations.map( ( s: any ): any => {
              return { key: s.id, value: s.name }
            } ) }
          />
        </div>
      }

      <div className="flex justify-center flex-col w-full">
        <TextField
          label=""
          value={ variantQuantity }
          name="quantity"
          type="number"
          min={ 0 }
          onChange={ ( quantity: any ): void => updateQuantity( quantity ) }
          placeholder="Quantity"
          wrapperClasses="w-full relative"
          containerClasses="w-full"
          fieldClasses="py-1 px-4 border rounded-2xl w-full text-blue-input placeholder-grey-input"
          isRequired
        />
      </div>

      <div className="flex justify-center flex-col w-full">
        <TextField
          label=""
          value={ variantOrder }
          name="order"
          type="number"
          onChange={ ( order: any ): void => updateOrder( order ) }
          min={ 1 }
          step={ 1 }
          placeholder="Order"
          wrapperClasses="w-full relative"
          containerClasses="w-full"
          fieldClasses="py-1 pl-7 pr-2 border rounded-2xl w-full text-blue-input placeholder-grey-input"
          isRequired
        />
      </div>

      <div className="flex justify-center flex-col w-full">
        <TextField
          label=""
          value={ variantPrice }
          name="price"
          type="number"
          onChange={ ( price: any ): void => updatePrice( price ) }
          min={ 0 }
          step={ 0.01 }
          placeholder="Price"
          wrapperClasses="w-full relative"
          containerClasses="w-full"
          fieldClasses="py-1 pl-7 pr-2 border rounded-2xl w-full text-blue-input placeholder-grey-input"
          isRequired
          poundMark
        />
      </div>

      <div className="flex items-center justify-center">
        { variant &&
          <>
            <button
              className="flex items-center justify-center rounded-lg text-white bg-red-500 w-8 h-8"
              onClick={ (): any => handleVariantChange( 'remove', { id: variant.id ?? 'new' }, tIndex ) }
            >
              <XMarkIcon />
            </button>
          </>
        }
        { !variant &&
          <button
            className="flex items-center justify-center rounded-lg text-white bg-green-500 w-8 h-8"
            onClick={ addVariant }
          >
            <PlusIcon />
          </button>
        }
      </div>
    </div>
  )
}
